<template>
  <div class="list-page-vacccin-pdf pt-3">
    <div class="homecare-topic-area">
      <VacccinTable/>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import VacccinTable from './VaccinTable.vue'
import { updatePageNumber, exportFileToPDF } from '@/js/commons/commons'
export default {
  components: {
    VacccinTable,
  },
  computed: {
    ...mapState({
      childName: state => state.homecare.vaccinPdf.child_name,
    }),
  },
  mounted() {
    updatePageNumber()
    exportFileToPDF(this.childName, this.$t('vaccination'), 'vaccin')
  },
}
</script>